import { Locale } from '@rover/constants/src/i18n/lingui.constants';
import { SERVICE_TYPE_FOR_SEO_SLUG } from '@rover/constants/src/search/seo.constants';
import appendUrlParams from '@rover/rsdk/src/modules/Network/appendUrlParams';
import {
  memberProfileFiltersToURLSearchParams,
  searchFiltersToMemberProfileSearchFilters,
} from '@rover/shared/js/search/utilities/filtersToURLSearchParams';
import type { SearchFilters } from '@rover/types/src/SearchFilters';

export default function getMemberProfileUrl(
  url: string,
  searchFilters: Partial<SearchFilters>,
  serviceTypeSlug: string,
  locale: Locale
): string {
  return appendUrlParams(
    url,
    memberProfileFiltersToURLSearchParams(
      searchFiltersToMemberProfileSearchFilters({
        ...searchFilters,
        serviceType: searchFilters.serviceType ?? SERVICE_TYPE_FOR_SEO_SLUG[serviceTypeSlug],
      }),
      locale
    ).toString()
  );
}
